import React from "react";
import { useIntl } from "react-intl";
import css from "./SundayMarker.module.css";
export var SundayMarker = function (props) {
    var formatMessage = useIntl().formatMessage;
    if (props.kind === "HOLIDAY") {
        var shortDate = "".concat(props.date.getDate(), ".").concat(props.date.getMonth() + 1, ".");
        var code = formatMessage({
            id: "ui-br-legaldeposits.periodicals.matrix.holiday.short.".concat(props.code),
        });
        var fullName = formatMessage({
            id: "ui-br-legaldeposits.periodicals.matrix.holiday.full.".concat(props.code),
        });
        var weekday = formatMessage({
            id: "ui-br-legaldeposits.periodicals.matrix.weekday.full.".concat(props.date.getDay()),
        });
        var title = "".concat(weekday, " ").concat(shortDate, " \u2014 ").concat(fullName);
        return (React.createElement("span", { className: css.holidayCell, title: title },
            React.createElement("span", { className: css.holidayCode }, code),
            React.createElement("span", { className: css.holidayDate }, shortDate)));
    }
    var weekdayShort = formatMessage({
        id: "ui-br-legaldeposits.periodicals.matrix.weekday.short.".concat(props.date.getDay()),
    });
    var dateLabel = "".concat(weekdayShort, " ").concat(props.date.getDate(), ".").concat(props.date.getMonth() + 1, ".");
    return (React.createElement("span", { className: css.marker, title: dateLabel, "data-testid": "sunday-marker", "aria-hidden": "true" }));
};
